export default __webpack_public_path__ + "static/media/deficiency.bb4df2af.jpg";